import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { AlertCircle, XCircle } from 'lucide-react';
export function ProblemSection() {
  const failedApproaches = ['Intentar "adivinar" por instinto sin una estructura técnica real.', 'Creer en mitos falsos (como que mirar a la izquierda siempre significa mentir).', 'Enfocarte en la cara e ignorar la parte más honesta del cuerpo: los pies.', 'Esperar a que la persona confiese con palabras algo que su cuerpo ya te confirmó hace diez minutos.'];
  return <section className="py-24 bg-surface relative overflow-hidden" data-id="element-196">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" data-id="element-197"></div>

      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-198">
        {/* Hook */}
        <div className="mb-20 text-center lg:text-left" data-id="element-199">
          <FadeIn data-id="element-200">
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-8 leading-tight" data-id="element-201">
              ¿Alguna vez has tenido la sensación de que alguien te está
              mintiendo directamente a la cara,{' '}
              <span className="text-accent" data-id="element-202">pero no puedes probarlo?</span>
            </h2>
          </FadeIn>

          <FadeIn delay={0.1} data-id="element-203">
            <p className="text-xl text-slate-300 mb-6 font-medium" data-id="element-204">
              ¿O has sentido que una persona está interesada en ti, pero sus
              palabras dicen lo contrario?
            </p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-205">
            <div className="space-y-6 text-lg text-slate-400 leading-relaxed" data-id="element-206">
              <p data-id="element-207">
                La mayoría de la gente vive en la oscuridad, guiándose solo por
                lo que escucha. Pero las palabras son una cortina de humo.
                Mientras la boca miente para quedar bien, el cuerpo está
                gritando la verdad en un lenguaje que el 99% de la población no
                sabe descifrar.
              </p>
              <p data-id="element-208">
                El problema es que nos enseñaron a confiar en el habla. Pasamos
                años aprendiendo idiomas, pero ni un solo día aprendiendo el
                lenguaje de los impulsos biológicos. Por eso pierdes negocios,
                fallas en tus citas y dejas que otros tomen ventaja sobre ti sin
                siquiera darte cuenta.
              </p>
            </div>
          </FadeIn>
        </div>

        {/* Why it doesn't work */}
        <div className="bg-background rounded-2xl p-8 sm:p-10 border border-red-900/30 relative" data-id="element-209">
          <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-surfaceHighlight border border-red-900/50 px-6 py-2 rounded-full flex items-center gap-2 shadow-xl" data-id="element-210">
            <AlertCircle className="w-5 h-5 text-red-400" data-id="element-211" />
            <span className="text-red-200 font-semibold text-sm uppercase tracking-wider" data-id="element-212">
              Por qué sigues fallando
            </span>
          </div>

          <FadeIn delay={0.3} data-id="element-213">
            <h3 className="text-2xl font-bold text-white mb-8 text-center mt-4" data-id="element-214">
              Lo que has intentado hasta ahora no funciona por estas razones:
            </h3>
          </FadeIn>

          <div className="space-y-4" data-id="element-215">
            {failedApproaches.map((approach, index) => <FadeIn key={index} delay={0.4 + index * 0.1} direction="left" data-id="element-216">
                <div className="flex items-start gap-4 p-4 rounded-xl bg-surface/50 border border-white/5 hover:bg-surface transition-colors" data-id="element-217">
                  <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-218" />
                  <p className="text-slate-300 text-lg" data-id="element-219">{approach}</p>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}